import React, { useEffect } from 'react'
import NavBar from '../componets/General/NavBar'
import Footer from '../componets/General/Footer'
import '../style/general.css'
import '../style/botonAnimado.css'
import Jumbotron from '../componets/General/Jumbotron'
import climaBg2 from '../assets/clima2.jpg'
import InnerDiv from '../componets/General/InnerDiv'
import JuegosList from '../componets/juegos/JuegosList'
import ProyectosList from '../componets/Universidades/proyectosList'
import ListaAnimaciones from '../componets/animaciones/ListaAnimaciones'
import ElectronicaList from '../componets/electronica/ElectronicalList'
import AlgoritmosList from '../componets/algoritmos/AlgoritmosList'


const Main = () =>{
    useEffect(()=>{
        window.scrollTo(0,0);
    },[])
return (
    <div>
        <NavBar/>
        <Jumbotron bg = "jumbotron rounded-0 text-white bg1" h = "NANOWEBMX" p = "Proyectos web útiles, interesantes o curiosos"/>        
        <InnerDiv img = {climaBg2} Link = "/clima" h = "Clima API" p = "Consulta como está el clima en cualquier parte del mundo, incluso en tu ciudad"/>
        <AlgoritmosList/>
        <ProyectosList/>
        <JuegosList/>   
        <ElectronicaList/>
        <ListaAnimaciones/>
        
        <Footer/>
    </div>
)
}

export default Main